export default {
    allBookings: null,
    bookingDetails: null,
    totalBookings: {
        totalItems: null,
        totalPages: null,
    },
};
